module.exports = __webpack_public_path__ + "media/images/team/dimi-56aac6cf146534a2c5cb71a6cfd6adaa.jpg";